import template from './loading.html';

class LoadingController {
    constructor() {}
}

LoadingController.$inject = [];

const LoadingComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: LoadingController,
    controllerAs: 'vm',
    bindings: {
        isLoading: '<',
        message: '@'
    }
};

export { LoadingComponent };
export { LoadingController };



// WEBPACK FOOTER //
// ./app/components/common/loading/loading.component.js